import { PERSONAL_LOANS_CALCULATOR_SET_VALUE } from '../../../actions/namPersonalLoansCalculator/calculator';
import { namPersonalLoansCalculatorValidation } from './calculator';

export const namPersonalLoansValidation = (store, next, action) => {
    if (action.type.startsWith(PERSONAL_LOANS_CALCULATOR_SET_VALUE)) {
        return namPersonalLoansCalculatorValidation(store, next, action);
    }

    return null;
};
